import { normalizeExpenseType } from "../../lib/expenseType.js";

function escapeDelimitedCell(value, delimiter) {
  const text = String(value ?? "");

  if (!text.includes(delimiter) && !text.includes("\"") && !text.includes("\n") && !text.includes("\r")) {
    return text;
  }

  return `"${text.replaceAll("\"", "\"\"")}"`;
}

function buildDelimitedText(headers, rows, delimiter = ",") {
  const lines = [
    headers.map((header) => escapeDelimitedCell(header, delimiter)).join(delimiter),
    ...rows.map((row) => row.map((value) => escapeDelimitedCell(value, delimiter)).join(delimiter))
  ];

  return `${lines.join("\n")}\n`;
}

export function buildBudgetExportText(rows, delimiter = ",") {
  const headers = ["Category", "Irregular", "Ongoing"];
  const bodyRows = rows
    .filter((row) => !row.archived)
    .map((row) => [
      row.category,
      Number(row.irregularBudget ?? 0),
      Number(row.ongoingBudget ?? 0)
    ]);

  return buildDelimitedText(headers, bodyRows, delimiter);
}

export function buildExpenseExportText(rows, delimiter = ",") {
  const headers = ["Amount", "Date", "Method", "Type", "Supplier", "Category", "Service"];
  const bodyRows = rows.map((row) => [
    Number(row.amount ?? 0),
    row.date ?? "",
    row.method ?? "",
    normalizeExpenseType(row.type),
    row.supplier ?? "",
    row.category ?? "",
    row.service ?? ""
  ]);

  return buildDelimitedText(headers, bodyRows, delimiter);
}

export function downloadTextFile(filename, text, mimeType = "text/plain;charset=utf-8") {
  const blob = new Blob([text], { type: mimeType });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.click();

  setTimeout(() => {
    URL.revokeObjectURL(objectUrl);
  }, 0);
}

export function exportDelimiterForFormat(format) {
  return format === "tsv" ? "\t" : ",";
}

export function exportMimeTypeForFormat(format) {
  if (format === "json") {
    return "application/json;charset=utf-8";
  }

  return format === "tsv"
    ? "text/tab-separated-values;charset=utf-8"
    : "text/csv;charset=utf-8";
}
